import numberDisplay from "../../../../components/numberDisplay/numberDisplay";
import { connect } from "react-redux";
export default connect((state) => ({
  value:
    state.membershipUnits.membershipUnits.totalNewMembers.canceledMembers.canceledMembersNumber,
  url: state.membershipUnits.membershipUnits.totalNewMembers.canceledMembers.canceledMembersLink,
  disableAnimation: state.membershipUnits.currentUser.qa,
  toolTipId: "membershipUnitsCancelMembers",
  toolTipContent: state.membershipUnits.membershipUnits.totalNewMembers.canceledMembers.tooltip
}))(numberDisplay);
